/**
 * Locale-aware formatters cho Phase 1 (vi).
 */

/** Format số Bean với separator nghìn theo locale Việt: 1.234.567 */
export function formatBean(value: number): string {
  return Math.floor(value).toLocaleString("vi-VN");
}

/** Format % với 1 số thập phân, sign trước khi dương. */
export function formatPct(value: number): string {
  const sign = value > 0 ? "+" : value < 0 ? "" : "";
  return `${sign}${value.toFixed(1)}%`;
}
